import { useState } from "react";
import { TicketPercent, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { money } from "@/components/am/shared";

export default function CouponField({ kind, amount, applied, onApply, testid = "coupon" }) {
  const [code, setCode] = useState(""); const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try {
      const r = (await api.post("/billing/coupon/check", { code, kind, amount })).data; onApply(r); setCode("");
      if (r.coupon_applied === false) toast.info(r.note); else toast.success(`Coupon ${r.code} applied: ${r.label}`);
    }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (applied) {
    return (
      <div className="flex flex-wrap items-center gap-2 text-xs text-emerald-600" data-testid={`${testid}-applied`}>
        <TicketPercent className="h-3.5 w-3.5" />{applied.coupon_applied === false ? `Coupon ${applied.code} not used (agent discount saves more)` : `Coupon ${applied.code}`}: −{money(applied.discount)}{applied.agent_discount ? ` incl. agent ${money(applied.agent_discount)}` : ""} · you pay <b className="font-mono">{money(applied.amount)}</b>
        <button onClick={() => onApply(null)} className="text-slate-500 hover:text-rose-500" data-testid={`${testid}-remove`}><X className="h-3.5 w-3.5" /></button>
      </div>
    );
  }
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testid}-field`}>
      <Input className="h-8 w-40" placeholder="Coupon code" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} data-testid={`${testid}-input`} />
      <Button size="sm" variant="secondary" disabled={!code || busy} onClick={check} data-testid={`${testid}-apply`}>Apply</Button>
    </div>
  );
}
